module.exports = __webpack_public_path__ + "img/sigtaufrontAsset 3@4x.60174612.png";